import { render } from "./simpeg-naikpangkat-prediksi-list-remote.vue?vue&type=template&id=50cffb32"
import script from "./simpeg-naikpangkat-prediksi-list-remote.vue?vue&type=script&lang=js"
export * from "./simpeg-naikpangkat-prediksi-list-remote.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__